import React from 'react'
import { Route, Switch } from 'react-router-dom'
import RequestsHome from './RequestsHome/RequestsHome'

const Home = () => (
  <Switch>
    <Route exact path="/solicitudes" component={RequestsHome} />
  </Switch>
)

export default Home
